export default "__VITE_ASSET__DWON7zvH__"